import { HttpService } from "../http"
import { ApiRoutes } from "../routes"
import { SessionService } from "../session"
import { Logger } from "../logger"
import { GetOrderResponse, PaginatedOrderResponse } from "../../models/transport/response/GetOrdersResponse"
import { container } from "../../../infrastructure/container"
import { OrderStatus } from "../../../infrastructure/models/common/orderStatus"
import { UpdateOrderBody } from "../../../infrastructure/models/transport/request/orderRequest"

export interface OrderService {
    /**  To Get Orders */
    getOrderDetails(franchiseId: string, page: number, limit: number | null): Promise<PaginatedOrderResponse>

    /**  To Update Orders status */
    updateOrderStatus(orderId: string, currentStatus: OrderStatus, newStatus: OrderStatus): Promise<any>

    /**To get orders by date */
    getOrdersByDateRange(franchiseId: string, fromDate: string, toDate: string, page: number, limit: number | null): Promise<PaginatedOrderResponse>
}

export class AppOrderService implements OrderService {
    /**
     * Initializes the login service with the HTTP service instance.
     * @param httpService - The HTTP service to send API requests.
     */
    private httpService = container.resolve<HttpService>("httpService")
    private sessionService = container.resolve<SessionService>("sessionService")
    private logger = container.resolve<Logger>("logger")

    async getOrderDetails(franchiseId: string, page: number, limit: number | null): Promise<PaginatedOrderResponse> {
        if (!franchiseId) {
            throw new Error("Franchise Id is required")
        }

        try {
            const base = `${ApiRoutes.GET_ORDERS}/${franchiseId}`
            const params = new URLSearchParams()
            params.set("page", String(page))
            if (limit !== null) params.set("limit", String(limit))

            const url = `${base}?${params.toString()}`
            return await this.httpService.get<PaginatedOrderResponse, { message: string }>(url)
        } catch (error) {
            this.logger.error("Error fetching order details:", error)
            throw error
        }
    }

    async updateOrderStatus(orderId: string, currentStatus: OrderStatus, newStatus: OrderStatus): Promise<any> {
        if (!orderId) throw new Error("OrderId is required")

        const url = `${ApiRoutes.GET_ORDERS}/${orderId}`

        const payload: UpdateOrderBody = { orderId, currentStatus, newStatus }

        return this.httpService.post(url, payload)
}
    async getOrdersByDateRange(franchiseId: string, fromDate: string, toDate: string, page: number, limit: number | null): Promise<PaginatedOrderResponse> {
        if (!franchiseId) {
            throw new Error("Franchise Id is required")
        }

        try {
            const base = `${ApiRoutes.GET_ORDERS}/${franchiseId}`
            const params = new URLSearchParams()

            params.set("fromDate", fromDate)
            params.set("toDate", toDate)
            params.set("page", String(page))
            if (limit !== null) params.set("limit", String(limit))

            const url = `${base}?${params.toString()}`
            return await this.httpService.get<PaginatedOrderResponse, { message: string }>(url)
        } catch (error) {
            this.logger.error("Error fetching orders by date range:", error)
            throw error
        }
    }
}